import { useEffect, useState } from "react"
import {Cloudinary} from "@cloudinary/url-gen";

const useGetCloudImage = (id) => {
    const [cloud, setCloud] = useState();

    useEffect(() => {
        if (!cloud) {
            const cld = new Cloudinary({
                cloud: {
                  cloudName: 'kosso-it'
                }
              });
            
            setCloud(cld);
        }

    }, [])

    if (cloud) {
        const image = cloud.image(id);

        return image;
    }
}

export default useGetCloudImage;
